import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'custNickName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'custUserId',
      type: 'input',
      label: '客户ID',
      placeholder: '请输入客户ID'
    },
    {
      field: 'corName',
      type: 'input',
      label: '主体名称',
      placeholder: '请输入主体名称'
    },
    {
      field: 'unionid',
      type: 'input',
      label: '客户unionid',
      placeholder: '请输入客户unionid'
    },
    {
      field: 'usedBy',
      type: 'input',
      label: '业务员姓名',
      placeholder: '请输入业务员姓名'
    },
    {
      field: 'sysDate',
      type: 'datepicker',
      label: '系统记录日期',
      otherOptions: {
        placeholder: '选择日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
